import React from 'react';
import { useLanguage } from '../components/LanguageContext';
import '../styles/Skills.css';

// Componente de habilidades
const Skills: React.FC = () => {
  const { language } = useLanguage(); // Obtén el idioma actual

  return (
    <div id="skills-content">
      {/* Utiliza el idioma actual para mostrar el título */}
      <h2>{language === 'es' ? 'Habilidades' : 'Skills'}</h2>
      <p>{language === 'es' ? 'Mis habilidades incluyen:' : 'My skills include:'}</p>
      <div className="skills-list">
        {/* Habilidad: Frontend */}
        <div className="skill-item">
          <img src="/frontend.png" alt="frontend" loading="lazy" className="skill-icon" />
          {language === 'es' ? 'Frontend:' : 'Frontend:'}
          <div className="skill-text">HTML5, CSS3, JavaScript, React.js, TypeScript</div>
        </div>

        {/* Habilidad: Backend */}
        <div className="skill-item">
          <img src="/backend.png" alt="backend" loading="lazy" className="skill-icon" />
          {language === 'es' ? 'Backend:' : 'Backend:'}
          <div className="skill-text"> Node.js, Java</div>
        </div>

        {/* Habilidad: Base de datos */}
        <div className="skill-item">
          <img src="/database-security.png" alt="database-security" loading="lazy" className="skill-icon" />
          {language === 'es' ? 'Base de datos:' : 'Database:'}
          <div className="skill-text">MongoDB, MySQL, SQLServer</div>
        </div>

        {/* Habilidad: Control de versiones */}
        <div className="skill-item">
          <img src="/git.png" alt="git" loading="lazy" className="skill-icon" />
          {language === 'es' ? 'Control de versiones:' : 'Version Control:'}
          <div className="skill-text">GitHub, Git</div>
        </div>

        {/* Habilidad: Otros */}
        <div className="skill-item">
          <img src="/linux.png" alt="linux" loading="lazy" className="skill-icon" />
          {language === 'es' ? 'Otros:' : 'Others:'}
          <div className="skill-text">Linux, Active Directory, Cisco CCNA, Python</div>
        </div>
      </div>
    </div>
  );
};

// Exportación del componente
export default Skills;

